let lastInteractionWasPointer = false

// Listening from load, not from a hook's mount, means a popup that mounts on the event that opened
// it still sees that event: mount effects run after it.
if (typeof window !== 'undefined') {
  window.addEventListener(
    'pointerdown',
    () => {
      lastInteractionWasPointer = true
    },
    true,
  )
  window.addEventListener(
    'keydown',
    () => {
      lastInteractionWasPointer = false
    },
    true,
  )
}

function isKeyboardInteraction(): boolean {
  return !lastInteractionWasPointer
}

function useKeyboardInteraction(): () => boolean {
  return isKeyboardInteraction
}

export { useKeyboardInteraction }
